// import SelectBox from '../SelectBox'
// import { useState } from "react";
import React from "react";

export function SubscriptionPage(props) {
  const {register, errors} = props.formHanding
  return (
    <div className="col-md-6 col-lg-12">
      <div className="card payment-card">
        <div className="card-body pt-0">
          <div className="row">
            <div className="col-4">
              <input  type="text"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
